import { Component, OnInit } from '@angular/core';
import { ContractService } from '../../_services';
import { ContractBase } from "./contract.base";

@Component({
    selector: 'contract-escalation-clause',
    template: require('./contract-escalation-clause.template.html')
})
export class ContractEscalationClauseComponent extends ContractBase implements OnInit {

    constructor(
        protected readonly contractService: ContractService) {
        super(contractService);
    }

    get escalationClause(): any {
        const contract: any = this.contract;
        return contract != null ? contract.escalationClause : null;
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-escalation-clause.component.ts